import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, unref, normalizeClass, renderSlot, createCommentVNode, createBlock, Fragment, createElementVNode } from "vue";
import LoadingIcon from "../../assets/icons/loading-icon.svg.js";
const _hoisted_1 = {
  key: 0,
  class: "btn__prefix"
};
const _hoisted_2 = { class: "btn__content" };
const _hoisted_3 = {
  key: 0,
  class: "btn__suffix"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    variant: { default: "default" },
    size: { default: "sm" },
    type: { default: "primary" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    circle: { type: Boolean, default: false },
    rounded: { default: "full" }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const handleClick = (e) => {
      if (props.loading || props.disabled) return;
      emit("click", e);
    };
    const btnClasses = computed(() => {
      return [
        `btn--${props.type}`,
        `btn--${props.size}`,
        `${props.variant}`,
        { "is-disabled": props.disabled },
        { "is-loading": props.loading },
        { "is-circle": props.circle }
      ];
    });
    const btnTextClasses = computed(() => {
      return [`btn__text--${props.type}`, { "is-disabled": props.disabled }, { "is-loading": props.loading }];
    });
    const btnStyles = computed(() => {
      const roundedValue = props.rounded?.trim() ?? "full";
      if (!roundedValue || roundedValue === "full") {
        return {};
      }
      if (roundedValue.startsWith("var(") || roundedValue === "0" || /^\d/.test(roundedValue)) {
        return { "--button-radius": roundedValue };
      }
      return { "--button-radius": `var(--radius-${roundedValue})` };
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        class: normalizeClass(["btn", unref(btnClasses)]),
        style: normalizeStyle(unref(btnStyles)),
        onClick: handleClick
      }, [
        _ctx.$slots.prefix || __props.loading ? (openBlock(), createElementBlock("span", _hoisted_1, [
          !__props.loading ? renderSlot(_ctx.$slots, "prefix", { key: 0 }, void 0, true) : createCommentVNode("", true),
          __props.loading ? (openBlock(), createBlock(unref(LoadingIcon), {
            key: 1,
            class: "w-5 h-5 animate-spin"
          })) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        !__props.circle ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createElementVNode("span", _hoisted_2, [
            createElementVNode("span", {
              class: normalizeClass(["btn__text", unref(btnTextClasses)])
            }, [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ], 2)
          ]),
          _ctx.$slots.suffix ? (openBlock(), createElementBlock("span", _hoisted_3, [
            renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ], 64)) : createCommentVNode("", true)
      ], 6);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Button.vue2.js.map
